import { ApiError } from "../errors.js";
import { OpsClient } from "./ops.js";
import { ClientBase } from "./base.js";
export class ExtensionsClient extends OpsClient {
    async openDiningTab(slug, tableCode) {
        return this.request("POST", `${this.siteBase(slug)}/dining-tabs`, { tableCode });
    }
    /** Rejects with 409 `version_conflict` when `version` is stale. */
    async addDiningTabItem(slug, tabId, version, item) {
        return this.request("POST", `${this.siteBase(slug)}/dining-tabs/${encodeURIComponent(tabId)}/items`, { version, item });
    }
    async settleDiningTab(slug, tabId, splits) {
        return this.request("POST", `${this.siteBase(slug)}/dining-tabs/${encodeURIComponent(tabId)}/settle`, { splits });
    }
    /** Kitchen board; accepts an access JWT or a staff-PIN kitchen token. */
    async listKdsTickets(slug, station) {
        const res = await this.request("GET", `${this.siteBase(slug)}/kds/tickets${ClientBase.query({ station })}`, undefined, true);
        return res.tickets;
    }
    async actOnKdsTicket(slug, ticketId, action) {
        return this.request("POST", `${this.siteBase(slug)}/kds/tickets/${encodeURIComponent(ticketId)}/action`, { action }, true);
    }
    async upsertBookableResource(slug, id, input) {
        return this.request("PUT", `${this.siteBase(slug)}/resources/${encodeURIComponent(id)}`, input, true);
    }
    /** Rejects with 409 `resource_conflict` on a downtime/reservation overlap. */
    async reserveBookableResource(slug, id, window) {
        return this.request("POST", `${this.siteBase(slug)}/resources/${encodeURIComponent(id)}/reserve`, window);
    }
    async createClassSession(slug, input) {
        return this.request("POST", `${this.siteBase(slug)}/class-sessions`, input, true);
    }
    async enrollClassSession(slug, sessionId, customerId) {
        return this.request("POST", `${this.siteBase(slug)}/class-sessions/${encodeURIComponent(sessionId)}/enroll`, { customerId });
    }
    async substituteClassInstructor(slug, sessionId, input) {
        return this.request("POST", `${this.siteBase(slug)}/class-sessions/${encodeURIComponent(sessionId)}/substitute`, input, true);
    }
    async promoteClassWaitlist(slug, sessionId, ttlMinutes) {
        return this.request("POST", `${this.siteBase(slug)}/class-sessions/${encodeURIComponent(sessionId)}/waitlist/promote`, ttlMinutes === undefined ? {} : { ttlMinutes }, true);
    }
    async previewQuote(slug, input) {
        return this.request("POST", `${this.siteBase(slug)}/quotes/preview`, input);
    }
    async createWorkOrder(slug, input) {
        return this.request("POST", `${this.siteBase(slug)}/work-orders`, input, true);
    }
    async putWholesaleContract(slug, input) {
        return this.request("PUT", `${this.siteBase(slug)}/wholesale/contracts`, input, true);
    }
    // Contacts + QR
    /** Owner contact-form inbox (GET /v1/contacts, orders:manage), newest first. */
    async listContacts() {
        const res = await this.request("GET", "/v1/contacts", undefined, true);
        return res.contacts;
    }
    /** Marks one contact message read (POST /v1/contacts/{id}/read, orders:manage). Idempotent. */
    async markContactRead(id) {
        await this.request("POST", `/v1/contacts/${encodeURIComponent(id)}/read`, {}, true);
    }
    /** Public QR image URL, usable directly as an `<img src>`. */
    siteQrUrl(slug, format) {
        return `${this.baseUrl}${this.siteBase(slug)}/qr${ClientBase.query({ format })}`;
    }
    /** GET /v1/sites/{slug}/qr (public) as raw bytes plus the response content type. */
    async fetchSiteQr(slug, format) {
        const res = await this.fetchImpl(this.siteQrUrl(slug, format), { method: "GET" });
        if (!res.ok) {
            let err = {};
            try {
                err = (await res.json());
            }
            catch {
                err = {};
            }
            throw new ApiError(res.status, err.code ?? "error", err.error ?? res.statusText);
        }
        return {
            contentType: res.headers.get("Content-Type") ?? "application/octet-stream",
            bytes: await res.arrayBuffer(),
        };
    }
}
//# sourceMappingURL=extensions.js.map